import { useCallback } from 'react'

import { useModal } from '@circlefin/modal-router'
import { FullScreen } from '@modals/layout'
import {
  GraphQLErrorBoundary,
  PropsErrorBoundary,
} from '@shared/components/errors'
import { useSettlementCreditWireInstructionQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { DepositInstructionsContent } from '../../components/DepositInstructionsContent/DepositInstructionsContent'
import { useSettlementCreditLine } from '../../hooks/settlement-credit-line'

export interface DepositInstructionsQueryProps {
  /**
   * Settlement Credit Line ID.
   */
  id?: string
}

export const DepositInstructions: React.FC<DepositInstructionsQueryProps> = ({
  id,
}) => {
  const { loading: settlementCreditLoading, translationKey } =
    useSettlementCreditLine()
  const { t } = useTranslation(`modals.${translationKey}`)
  const { t: tCommon } = useTranslation('common')

  const { close } = useModal()

  const { loading, data, error, refetch } =
    useSettlementCreditWireInstructionQuery({
      variables: {
        id: id ?? '',
      },
    })

  const handleContinue = useCallback(() => {
    close()
  }, [close])

  if (settlementCreditLoading) return null
  return (
    <FullScreen hideProgressBar>
      <h2 className="mb-2 text-center type-h-section-lg">
        {t('depositInstructions.title')}
      </h2>

      <div className="mx-auto max-w-md">
        <h3 className="mb-9 text-center text-neutral type-body-sm">
          {t('depositInstructions.subtitle')}
        </h3>
        <PropsErrorBoundary<DepositInstructionsQueryProps>
          props={{ id }}
          variant="component"
        >
          {() => (
            <GraphQLErrorBoundary
              error={error}
              retry={refetch}
              variant="component"
            >
              <DepositInstructionsContent
                ctaButtonText={tCommon('close')}
                loading={loading}
                onContinue={handleContinue}
                wireInstruction={data?.settlementCreditWireInstruction}
              />
            </GraphQLErrorBoundary>
          )}
        </PropsErrorBoundary>
      </div>
    </FullScreen>
  )
}
